import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../environment/environment';
import { UtmSegmentosResponse } from '../interfaces/utm';

@Injectable({
  providedIn: 'root'
})
export class UtmSegmentosService {
  private apiUrl = environment.api;
  private segmentosMarketCache$ = new BehaviorSubject<any[]>([]);
  private segmentosTelemarketingCache$ = new BehaviorSubject<any[]>([]);
  private loaded = false;

  constructor(private http: HttpClient) {}

  getSegmentosMarket(): Observable<UtmSegmentosResponse> {
    return this.http.get<UtmSegmentosResponse>(`${this.apiUrl}/utm/segmentos-marketing`).pipe(
      tap((response: any) => {
        let segmentos: any[] = [];

        if (response.success && response.data) {
          // Converter objeto para array se necessário
          segmentos = Array.isArray(response.data)
            ? response.data
            : Object.values(response.data);
        } else if (response.data) {
          segmentos = Array.isArray(response.data)
            ? response.data
            : Object.values(response.data);
        } else if (Array.isArray(response)) {
          segmentos = response;
        }

        this.segmentosMarketCache$.next(segmentos);
        this.loaded = true;
      })
    );
  }

  getSegmentosTelemarketing(): Observable<UtmSegmentosResponse> {
    return this.http.get<UtmSegmentosResponse>(`${this.apiUrl}/utm/segmentos-telemarketing`).pipe(
      tap((response: any) => {
        let segmentos: any[] = [];

        if (response.success && response.data) {
          // Converter objeto para array se necessário
          segmentos = Array.isArray(response.data)
            ? response.data
            : Object.values(response.data);
        } else if (response.data) {
          segmentos = Array.isArray(response.data)
            ? response.data
            : Object.values(response.data);
        } else if (Array.isArray(response)) {
          segmentos = response;
        }

        this.segmentosTelemarketingCache$.next(segmentos);
        this.loaded = true;
      })
    );
  }


  getSegmentoById(id: string): any | null {
    // Busca primeiro no cache de market, depois no de telemarketing
    const segmentosMarket = this.segmentosMarketCache$.value;
    const segmentosTelemarketing = this.segmentosTelemarketingCache$.value;

    return segmentosMarket.find(s => s.id === id) ||
           segmentosTelemarketing.find(s => s.id === id) ||
           null;
  }

  getSegmentoNomeById(id: string): string {
    const segmento = this.getSegmentoById(id);
    return segmento ? (segmento.descricao || segmento.nome || id) : id;
  }

  getSegmentosMarketCache(): any[] {
    return this.segmentosMarketCache$.value;
  }

  getSegmentosTelemarketingCache(): any[] {
    return this.segmentosTelemarketingCache$.value;
  }

  isLoaded(): boolean {
    return this.loaded;
  }
}
